import { Gift } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { COPPER } from "./VestaAuth";

export function PremioDialog({ p, categoria, imgSrc, onClose }) {
  return (
    <Dialog open={!!p} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-h-[90vh] max-w-2xl overflow-y-auto border-neutral-800 bg-neutral-950 text-white" data-testid="vesta-premio-dialog">
        {p && <>
          <DialogHeader><DialogTitle className="font-heading text-2xl" data-testid="vesta-premio-dialog-title">{p.name}</DialogTitle></DialogHeader>
          <div className="aspect-video overflow-hidden rounded-xl bg-neutral-900">
            {p.image_url ? <img src={imgSrc(p.image_url)} alt={p.name} className="h-full w-full object-contain" /> : <div className="flex h-full items-center justify-center"><Gift className="h-10 w-10 text-neutral-600" /></div>}
          </div>
          <div className="flex flex-wrap items-baseline justify-between gap-2">
            <span className="text-xs uppercase tracking-widest text-neutral-400">{categoria || "Catalogo Vesta"}{p.type ? ` · ${p.type}` : ""}</span>
            <span className="font-mono text-2xl font-black" style={{ color: COPPER }} data-testid="vesta-premio-dialog-punti">{p.costo_punti} <span className="text-xs font-semibold text-neutral-400">Punti Vesta</span></span>
          </div>
          <p className="whitespace-pre-line text-sm leading-relaxed text-neutral-300" data-testid="vesta-premio-dialog-desc">{p.description || "Descrizione non disponibile."}</p>
          {p.specs?.length > 0 && (
            <dl className="divide-y divide-neutral-900 rounded-xl border border-neutral-800 text-sm" data-testid="vesta-premio-dialog-specs">
              {p.specs.map((s, i) => <div key={i} className="flex justify-between gap-4 px-3 py-2"><dt className="text-neutral-400">{s.label}</dt><dd className="text-right">{s.value}</dd></div>)}
            </dl>
          )}
          <p className="text-[11px] text-neutral-500">Per prenotare contatta il tuo referente Torri.</p>
        </>}
      </DialogContent>
    </Dialog>
  );
}
